// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1m9hA","name":"ConsentHeader_name__14t3g","birthday":"ConsentHeader_birthday__oFAkv","skeleton":"ConsentHeader_skeleton__3zMzb"};